import { Text, Flex, Heading, Box, Image, SimpleGrid, Grid, forwardRef, GridProps, HStack, StackProps } from "@chakra-ui/react"
import { AvatarCard, AVATAR_CARD_MODES } from "@components/Cards/AvataraCard/AvatarCard";
import { MetaCard } from "@components/Cards/MetaCard/MetaCard";
import { generatePageUrl, preparePostUrl } from "@core/utils";
import { Link } from "@reach/router";
import React from "react";

export const SecondaryPostTile = forwardRef<StackProps, "div">(({ post, ...rest }, ref) => {
    const { author, slug, title, excerpt, featuredImage } = post;
    return (
        <HStack as={Link} to={preparePostUrl(post)} flexWrap={{base: "wrap", md: 'nowrap'}} spacing="50px" ref={ref} {...rest} w="100%">
            <Box flexGrow={1 as any} w="100%" maxW="510px">
                <AvatarCard mode={AVATAR_CARD_MODES.SHORT} author={author} mb="13px" />
                <Heading fontSize="26px" mb="10px">{title}</Heading>
                <Box sx={{
                    'a.more-link': {
                        'display': 'none',
                    }
                }} dangerouslySetInnerHTML={{ __html: excerpt }} mb="10px" />
                <MetaCard article={post} fontSize="10px" />
            </Box>
            <Image loading="lazy" src={featuredImage?.node?.blogSmall} alt="" w="100%" maxW="252px" maxH="150px" objectFit="cover" />
        </HStack>
    )
});
9
